import React from 'react';
import './LoadingBlock.css';
import classNames from "classnames"
import useTranslate from "../../modules/local/useTranslate";

const LoadingCircle = ({style = {}, className = "h-48"}) => {
    const t = useTranslate()
    return (
        <div style={{height: '100%', minHeight: '16rem', ...style}}
             className={classNames("loading-block-container flex flex-col flex-center gap-2", className)}
        >
            <svg className="spinner-loading-circle" viewBox="25 25 50 50">
                <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="4"/>
            </svg>
            <div className="loading-text">
                <span>{t("loading")}</span>
                <div className="dot-loading">.</div>
                <div className="dot-loading">.</div>
                <div className="dot-loading">.</div>
            </div>
        </div>
    );
};

export default React.memo(LoadingCircle);
